/* template */
<template minapp="mpx" xlang="wxml"><es-drawer-bottom :title="(title)" :show="(show)" showDefaultNav @close="close" :navbarStyle="(curNavBarStyle)" :customStyle="(curCustomStyle)" class="main"><div class="drawer-container"><div class="publicity"><div class="explain"><div v-for="(item, index) in (explainText)" :key="item.index" class="ticket-title"><div>{{ item.title }}</div><div class="ticket-title-cash">{{ item.case }}</div></div><div class="rules"><div v-for="(item, index) in (handing_fee_detail)" :key="item.inde" :class="({rule:true,checked:item.status})"><div class="time">{{item.key}}</div><div class="handle"><div class="handle-text">{{item.value}}</div><div class="handle-fee highlight">{{item.fee}}</div><div v-show="(item.status)" class="highlight">当前</div></div></div></div><div class="spring-festival-refund" v-if="(showSpringFestivalRefund)">{{springFestivalRefund}}</div></div><tips-card title="退票说明" sideTitle="查看详情" :sideIcon="(true)" sideColor="#1473FF" :texts="(refundTipTexts)" @sideClick="onSideClick"/></div><div class="footer"><div class="footer-left"><div class="foooter-left-text">预计退款金额</div><div class="footer-left-amount"><span v-if="(total_refund >= 0)">¥</span><span class="amont-money">{{ total_refund }}</span></div></div><mpx-view @tap="confirmRefund" class="footer-right">确认退票</mpx-view></div></div></es-drawer-bottom></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m09f95c02"}'>
  .main
    /deep/ .es-navbar
      background-color #F0F1F4
    /deep/ .drawer-container
      overflow auto
  .drawer-container
    width 100vw
    background #F0F1F4
    border-radius 16px 16px 0 0
    display flex
    flex-direction column
    align-items center
    overflow auto
    .publicity
      box-sizing border-box
      width 100%
      display flex
      flex-direction column
      padding 0px 12px 97px
      .explain
        box-sizing border-box
        background #FFFFFF
        border-radius 8px
        padding 8px 12px 12px
        margin-bottom 10px
        .ticket-title
          display flex
          height 20px
          align-items center
          justify-content space-between
          font-family PingFangSC-Medium
          font-size 16px
          font-weight normal
          letter-spacing 0px
          color #000000
          margin 4px 0 12px
          &-cash
            color #1473FF
        .rules
          border-radius 8px
          box-sizing border-box
          border 1px solid rgba(0, 0, 0, 0.08)
          .rule
            height 34px
            display flex
            border-top 1px solid rgba(0, 0, 0, 0.08)
            font-family PingFangSC-Regular
            font-size 12px
            font-weight normal
            letter-spacing 0px
            color #666666
            &:first-child
              background rgba(231, 241, 255, 0.3)
              border none
              font-family PingFangSC-Medium
            &.checked
              background linear-gradient(270deg, #FFF4EE 0%, rgba(255, 255, 255, 0) 99%)
              border-right 2px solid #FF7D41
            .time
              width 180px
              height 100%
              flex none
              display inline-flex
              align-items center
              padding-left 12px
            .handle
              border-left 1px solid rgba(0, 0, 0, 0.08)
              height 100%
              flex 1
              display inline-flex
              align-items center
              justify-content space-between
              padding 0 12px
              &-text
                flex none
                margin-right 5px
              &-fee
                flex 1
              .highlight
                color #FF7D41
    .footer
      width 100%
      box-sizing border-box
      display flex
      background #ffffff
      position fixed
      bottom 0px
      height 85px
      padding 16px 16px 21px
      justify-content space-between
      align-items center
      .footer-left
        display flex
        align-items flex-end
        font-family PingFangSC-Medium
        font-size 12px
        font-weight normal
        line-height 14px
        color #333333
        .foooter-left-text
          margin-right 12px
        .footer-left-amount
          color #1473FF
          .amont-money
            font-size 22px
      .footer-right
        font-family PingFangSC-Medium
        font-size 16px
        font-weight normal
        line-height 19px
        text-align center
        letter-spacing 0px
        color #FFFFFF
        padding 13px 28px
        background-color #1473FF
        border-radius 8px
    .spring-festival-refund
      color #FF7D41
      font-size 12px
      background #FFF4EE
      border-radius 8px
      padding 8px 9px 9.5px
      margin-top 12px
      line-height 18px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m09f95c02"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex09f95c02%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex09f95c02%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m09f95c02"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index09f95c02/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'tips-card':getComponent(require("../tips-card/index.mpx?isComponent&outputPath=components%2Findex7169e18e%2Findex")),'es-drawer-bottom':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/drawer-bottom/index.mpx?isComponent&outputPath=components%2Findexeb3fdc9e%2Findex")),'es-icon':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
